import React, { useState, useEffect } from "react";
import FaqSection from "./FaqSection";
import { useNavigate } from "react-router-dom";

const Article = ({ id }) => {
    const [CurrentArticle, setCurrentArticle] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (id) {
            // Remove hyphens from id
            const formattedId = id.replace(/-/g, '');
            // Dynamically import the component with the same name as the id
            import(`./${formattedId}`)
                .then((module) => {
                    setCurrentArticle(() => module.default);
                })
                .catch((error) => {
                    console.error(`Error loading article component: ${error}`);
                    navigate('/'); // Redirect to home if article not found
                });
        }
    }, [id, navigate]);

    return (
        <div className="container mx-auto px-4 py-8 flex flex-col justify-center">
            {/* Main Article */}
            {CurrentArticle ? <CurrentArticle /> : <p>Loading...</p>}

            {/* Call to Action */}
            <a href="/asistente" className="mt-10 text-center">
                <button className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-lg px-5 py-2.5">
                    Conoce las cargas de cualquier subasta del BOE
                </button>
            </a>

            {/* FAQ Section */}
            <div className="mt-10 pb-40">
                <FaqSection />
            </div>
        </div>
    );
};

export default Article;